var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-container"},[(_vm.label)?_c('div',{staticClass:"qr-code-label"},[_vm._v("scan me with your phone")]):_vm._e(),_c('div',{staticClass:"qr-code"},[(_vm.src != null)?_c('img',{attrs:{"src":_vm.src,"alt":"qr code"}}):_c('Loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }